module.exports = __webpack_public_path__ + "img/sun-01.3b4467de.svg";